import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { parseHTML } from '../../utils/dom'
import { PaginationComponent } from './pagination'
import { $el, $elParent } from 'src/scripts/utils/utils'

const PAGINATION_COMPONENT_SELECTOR = 'pagination-component'
const PAGINATION_LOAD_BUTTON_SELECTOR = 'pagination-load-button'

export class PaginationLoadButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.fetchResults()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.fetchResults()
    }
  }

  fetchResults(): void {
    if (this.dataset.url) {
      this.setLoading(true)

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)

          this.setLoading(false)
          this.updateFromHTML(html)
          this.updatePaginationFromHTML(html)
        })
        .catch(() => {
          console.log('Error in pagination load button component')
        })
    }
  }

  updatePaginationFromHTML(html: Document): void {
    const pagination: PaginationComponent = $elParent(
      PAGINATION_COMPONENT_SELECTOR,
      this,
    )
    pagination?.updateTargetsFromHTML(html)
    pagination?.updateFromHTML(html)
  }

  setPaginationUrl(newUrl: string): void {
    this.dataset.url = newUrl
  }

  removePagination(): void {
    const pagination: PaginationComponent = $elParent(
      PAGINATION_COMPONENT_SELECTOR,
      this,
    )
    pagination?.remove()
  }

  updateFromHTML(html: Document): void {
    const newBtn: PaginationLoadButton = $el(
      PAGINATION_LOAD_BUTTON_SELECTOR,
      html,
    )
    if (newBtn) {
      this.setPaginationUrl(newBtn.dataset.url)
    } else {
      this.removePagination()
    }
  }

  setLoading(isLoading: boolean): void {
    this.toggleAttribute('disabled', isLoading)
    this.classList.toggle('loading', isLoading)
  }
}
